import { useState } from 'react';
import { Archive } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { useArchiveNotification } from 'hooks/useUserNotifications';

type UserNotificationArchiveActionProps = {
  notificationId: string;
  archived: boolean;
};

export function UserNotificationArchiveAction({
  notificationId,
  archived,
}: UserNotificationArchiveActionProps) {
  const [open, setOpen] = useState(false);
  const archiveNotification = useArchiveNotification();

  if (archived) return null;

  return (
    <>
      <Button
        type="button"
        size="icon-xs"
        variant="ghost"
        aria-label="Archive notification"
        onClick={(event) => {
          event.stopPropagation();
          setOpen(true);
        }}
      >
        <Archive className="tw:h-4 tw:w-4" />
      </Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent className="dark">
          <AlertDialogHeader>
            <AlertDialogTitle>Archive notification</AlertDialogTitle>
            <AlertDialogDescription>
              Archive this notification? It will move to Historical.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              disabled={archiveNotification.isPending}
              onClick={(event) => event.stopPropagation()}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              type="button"
              variant="destructive"
              disabled={archiveNotification.isPending}
              onClick={(event) => {
                event.stopPropagation();
                void archiveNotification
                  .mutateAsync({ notificationId })
                  .then(() => setOpen(false));
              }}
            >
              Archive
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
